import {inject} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {catchError, filter, map, of, take, timeout} from 'rxjs';
import {PermissionService} from '../../services/permission.service';
import {TaAppStore} from '../../state/clcta-store';

// Mirrors the nav menu: a page opens by URL only if PermissionService.canAccessPath shows it,
// otherwise the user lands on home. Paths canAccessPath does not know pass.
//
// Angular subscribes all of a route's canActivate guards at once, so on a deep link this runs
// before the session has loaded and must wait for it itself, the same way UserActiveGuard does.
export const minimumPermissionGuard: CanActivateFn = (route) => {
  const store = inject(TaAppStore);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  // The matched route's path, not state.url: matrix params, encoding and secondary outlets in the
  // raw URL would sidestep canAccessPath's exact match.
  const path = '/' + route.pathFromRoot.map(r => r.routeConfig?.path).filter(Boolean).join('/');
  const check = (): boolean | UrlTree =>
    permissionService.canAccessPath(path) || router.createUrlTree(['/home']);

  if (store.session().details !== null) {
    return check();
  }

  return toObservable(store.session).pipe(
    filter(s => s.details !== null),
    take(1),
    map(() => check()),
    timeout(30000),
    catchError(() => of(false)),
  );
};
